<template>
    <CodiceFeanorView tool-module="exif" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
